<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 header-box">
        <img class="logo astech-logo float-md-left" src="../../assets/astech.png" alt="Astech Logo">
        <img class="af-logo float-md-right" :src="loginLogo.src" alt="">
      </div>
    </div>
    <div class="background-container">
      <div class="row md-4">
        <div class="col">
          <h1 class="welcome-title text-center">Create a new password</h1>
        </div>
      </div>
      <div class="container" style="max-width: 480px; margin-top: 50px;">
        <div class="form-group" style="margin-bottom: 20px;">
          <input type="email" class="form-control" v-model="email" disabled />
        </div>

        <div class="form-group password-wrapper">
          <input :type="showPassword ? 'text' : 'password'" class="form-control" placeholder="New password"
            v-model="password" />
          <font-awesome-icon class="eye-icon" :icon="['far', showPassword ? 'eye' : 'eye-slash']"
            @click="showPassword = !showPassword" />
        </div>
        <div v-if="passwordRules && !passwordValid" class="password-rules" style="margin-top: -20px; margin-right: 90px;">
          <small>{{ passwordRules.description }}</small>
        </div>
        <div class="form-group">
          <input :type="showPassword ? 'text' : 'password'" class="form-control" placeholder="Confirm password"
            v-model="passwordConfirmation" />
        </div>

        <button class="btn btn-primary" :disabled="loading" @click="submit">
          {{ loading ? "Saving..." : "Save" }}
        </button>

        <p v-if="successMessage" style="color: green; margin-top: 12px;">{{ successMessage }}</p>
        <p v-if="errorMessage" style="color: red; margin-top: 12px;">{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { LOGIN_LOGO } from "@/config/featureFlags";

export default {
  data() {
    return {
      loginLogo: LOGIN_LOGO,
      token: "",
      email: "",
      password: "",
      passwordConfirmation: "",
      showPassword: false,
      loading: false,
      errorMessage: "",
      successMessage: "",
      passwordRules: null,
    };
  },
  computed: {
    passwordChecklist() {
      const pw = this.password || '';
      const min = this.passwordRules?.min ?? 8;

      return {
        min: pw.length >= min,
        letter: /[A-Za-z]/.test(pw),
        number: /\d/.test(pw),
      };
    },
    passwordValid() {
      return (
        this.passwordChecklist.min &&
        this.passwordChecklist.letter &&
        this.passwordChecklist.number
      );
    },
  },
  async mounted() {
    // Read from query string
    const q = this.$route.query;
    this.token = q.token || "";
    this.email = q.email || "";

    if (!this.token || !this.email) {
      this.errorMessage = "Invalid or expired reset link. Please request a new one.";
    }
    await this.fetchPasswordRules();
  },
  methods: {
    async submit() {
      this.errorMessage = "";
      this.successMessage = "";

      if (!this.token || !this.email) return;

      if (!this.password || !this.passwordConfirmation) {
        this.errorMessage = "Please enter and confirm your password.";
        return;
      }
      if (this.password !== this.passwordConfirmation) {
        this.errorMessage = "Passwords do not match.";
        return;
      }

      this.loading = true;
      try {
        await axios.post("/api/reset-password", {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        });

        this.successMessage = "Password updated. You can now log in.";
        setTimeout(() => this.$router.push("/"), 1200);
      } catch (err) {
        // Laravel ValidationException will come back as errors
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.errors?.email?.[0] ||
          "Could not reset password. Please request a new link.";
        this.errorMessage = msg;
      } finally {
        this.loading = false;
      }
    },
    async fetchPasswordRules() {
      try {
        const res = await axios.get('/api/auth/password-rules');
        this.passwordRules = res.data;
      } catch (e) {
        console.error('Failed to fetch password rules', e);
        this.passwordRules = { description: 'Minimum 8 characters, at least 1 letter and 1 number.', min: 8, requires: { letters: true, numbers: true } };
      }
    },
  },
};
</script>


<style scoped>
.row {
  margin-left: 0px;
  margin-right: 0px;
}

.welcome-title {
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.logo {
  height: 80px;
  /* Adjust as necessary */
  width: 150px;
}

button {
  background: #0a407a;
  color: white;
  padding: 10px;
  width: 40%;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  margin-top: 20px;
  margin-bottom: 30px;
}

button:hover {
  background: #042344;
}

h1 {
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  font-size: 50px;
  /* You can add more fallback fonts after Helvetica */
}

.astech-logo {
  margin-top: 22px;
  margin-left: 6%;
  width: 180px;
  height: 75px;
  margin-bottom: 10px;
}

.af-logo {
  margin-top: 45px;
  margin-bottom: 10px;
  max-width: 300px;
  max-height: 40px;
  margin-right: 5%;

}

.container {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.background-container {
  background-color: #0e82c51c;
  /* Adjust as needed */
  flex: 1;
  /* Makes it take the remaining height */
  padding: 20px;
}

.header-box {
  border-bottom: 1px solid #a8afbd;
  display: flex;
  justify-content: space-between;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.form-group label {
  width: 160px;
  margin-right: 30px;
  text-align: right;
  margin-bottom: 0px;
}

.form-group input.form-control,
.form-group select.form-control {
  flex: 1;
  width: auto;
  margin-left: 0;
  margin-bottom: 0px;
}

.form-control {
  border-radius: 5px;
}

.eye-icon {
  position: absolute;
  margin-left: 450px;
  cursor: pointer;
  color: grey;
}

.eye-icon:hover {
  color: rgb(77, 77, 77);
}
</style>